interface GetIsIntegrationIngestionInProgressParams {
  onboardingProgress: number | undefined;
  isDisabled: boolean;
  isIncompleteIntegration: boolean;
}

export const getIsIntegrationIngestionInProgress = ({
  onboardingProgress,
  isDisabled,
  isIncompleteIntegration,
}: GetIsIntegrationIngestionInProgressParams) => {
  if (isDisabled || isIncompleteIntegration) {
    return false;
  }

  if (onboardingProgress === undefined) {
    return false;
  }

  return onboardingProgress < 100;
};
